<template>
  <div>
    <div class="section-right-content-box" style="min-width:1046px">
      <div class="box-shadow top-box">
        <div class="global-title">
          客户画像
        </div>
        <!-- 提示栏 -->
        <div style="padding: 0px 23px 0px 28px;">
        <div class="background">
          <span class="title"></span>&nbsp;
          <span class="tips">从不同的基础属性维度，分析店铺会员的占比情况</span>
        </div>
        </div>
      </div>
      <div style="padding: 23px 23px 10px 28px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">性别</div>
            <div class="clos">
              <page-order-money :sex="sex" v-if="show"></page-order-money>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">年龄</div>
            <div class="clos">
              <age :year="year" v-if="show"></age>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">职业</div>
            <div class="clos">
              <occupation :position="position" v-if="show"></occupation>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="padding: 23px 23px 30px 28px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">会员等级</div>
            <div class="clos">
              <membership :level="level" v-if="show"></membership>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">是否为粉丝</div>
            <div class="clos">
              <fans :fans="fans" v-if="show"></fans>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">
              地区分布（统计用户分布最多的五个省份）
            </div>
            <div class="clos">
              <div
                id="order-care"
                :style="{ width: '100%' }"
                class="chartheight"
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { portrait } from "@/api/analysis/rfmStandard";
import { mapState, mapMutations } from "vuex";
import pageOrderMoney from "./chart/page-order-money";
import occupation from "./chart/occupation";
import fans from "./chart/fans";
import age from "./chart/age";
import membership from "./chart/membership";
export default {
  name: "customerAnalysisSelfSupport",
  data() {
    return {
      sex: {}, //性别
      year: {}, //年龄
      position: {}, //职业
      level: {}, //会员等级
      fans: {}, //是否为粉丝
      distribution: {}, //地区分布
      show: false,
      datasetReset:[],
      dataReset:[],
      shopMemberType: '',
    };
  },
  components: {
    pageOrderMoney,
    occupation,
    fans,
    age,
    membership,
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
  },
  mounted: function() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  created() {
    this.shopMemberType = this.shopInfo.shopMemberType;
    this.portrait();
  },
  watch: {
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
        this.portrait();
      }
    }
  },
  methods: {
    portrait() {
      portrait()
        .then((res) => {
          this.sex = res.data.sex;
          this.year = res.data.age;
          this.position = res.data.profession;
          if (this.shopMemberType == '3' || this.shopMemberType == '5' ) {
            var brandMemberLevel = res.data.brandMemberLevel;
            this.level = {
              level1Count: brandMemberLevel.brandLevel1Count,
              level2Count: brandMemberLevel.brandLevel2Count,
              level3Count: brandMemberLevel.brandLevel3Count,
              level4Count: brandMemberLevel.brandLevel4Count,
              level5Count: brandMemberLevel.brandLevel5Count,
            };
          } else {
            this.level = res.data.memberLevel;
          }
          this.fans = res.data.shopFans;
          this.distribution = res.data.province.provinceMap;
          this.show = true;
          for (let i in  this.distribution){
              this.dataReset.push(i);
              this.datasetReset.push(this.distribution[i])
          }  
          this.drawOrderCareBar()
        })
        .catch(() => {});
    },
    //绘制柱状图
    drawOrderCareBar() {
      let orderCareBarChartOne = this.$echarts.init(
        document.getElementById("order-care"),
        "light"
      ); //初始化echats实例
      let dataReset = this.datasetReset;
      let datasetReset = this.dataReset;
      orderCareBarChartOne.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} 人",
        },
        xAxis: {
          type: "category",
          data: datasetReset,
          axisLabel: {
            interval: 0,
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 10,
          bottom: 0,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666",
            },
          },
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  // show: true, //开启显示
                  // position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666",
                    fontSize: 14,
                  },
                },
                color: function(params) {
                  var colorList = [
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            data:dataReset,
          },
        ],
      });
      window.onresize = function() {
        orderCareBarChartOne.resize();
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section-right-content-box {
  margin-top: 10px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  .echarts {
    width: 100%;
    height: 40px;
    background: #fafafa;
    opacity: 1;
    padding-left: 20px;
    line-height: 40px;
  }
  .clos {
    width: 100%;
    height: 310px;
                @media screen and (max-width: 1400px){
              margin-top: 10px;
          height: 280px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 10px;
          height: 250px;
        }

    background: #ffffff;
    border: 1px solid #f3f4f7;
    opacity: 1;
    padding-left: 20px;
    .chartheight{
      height: 300px ;
            @media screen and (max-width: 1400px){
              margin-top: 10px;
          height: 250px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 10px;
          height: 230px;
        }
}
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    margin-top: 26px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
}
</style>
